import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialog: {
    margin: "0 auto",
    [theme.breakpoints.up("lg")]: {
      width: "100%"
    },
    "& $dialogContent": {
      padding: "inherit"
    }
  },
  dialogPaper: {
    maxWidth: "100%",
    maxHeight: "100%",
    height: "100%",
    margin: "0px",
    [theme.breakpoints.down("xs")]: {
      width: "100vw",
      borderRadius: 0
    },
    [theme.breakpoints.up("sm")]: {
      maxWidth: 412,
      width: 412,
      height: "90%"
    },
    "&.assignToMeView": {
      width: 292,
      height: 160,
      borderRadius: 3
    }
  },
  dialogTitle: {
    padding: 0,
    "&.assignToMeView": {
      padding: "13px 16px 3px 20px"
    }
  },
  dialogContent: {
    padding: "0",
    "&.loading": {
      display: "flex"
    },
    "&.assignToMeView": {
      padding: "0 16px 16px 20px",
      overflowY: "hidden"
    }
  },
  dialogActions: {
    padding: 0,
    "&.assignToMeView": {
      padding: 8
    }
  },
  listItem: {
    padding: "0",
    borderBottom: "1px solid #EEEEEE",
    "&:nth-child(even)": {
      backgroundColor: "#F6F6F6"
    }
  },
  listItemText: {
    fontSize: "18px",
    textAlign: "left",
    wordBreak: "break-word"
  },
  listItemIconCheck: {
    width: "30px",
    height: "30px",
    backgroundColor: "#fff",
    padding: "4px",
    marginRight: "12px",
    borderRadius: "50%",
    boxShadow: "0 0 4px 0 #ccc",
    border: "1px solid #bbb",
    "& path": {
      display: "none"
    }
  },
  listItemIconCheckSelected: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.common.black,
    "& path": {
      display: "initial"
    }
  },
  listItemButton: {
    justifyContent: "space-between",
    padding: "8px 16px",
    textTransform: "initial"
  },
  vetList: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  confirmationContainer: {
    display: "flex",
    flex: "auto",
    flexDirection: "column",
    width: "100%"
  },
  confirmationHeader: {
    display: "grid",
    gridTemplateColumns: "64px 1fr 64px",
    padding: "20px 16px 12px",
    borderBottom: " 1px solid #CCCCCC",
    position: "sticky",
    top: "0",
    backgroundColor: "#fff",
    zIndex: 2,
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      flexDirection: "column",
      paddingTop: 16
    },
    "& > .MuiButton-root": {
      [theme.breakpoints.down("xs")]: {
        minWidth: "58px",
        width: "58px"
      }
    },
    "& > .MuiButton-text": {
      [theme.breakpoints.down("xs")]: {
        padding: "6px 4px"
      }
    }
  },
  confirmationHeaderTitle: {
    fontFamily: "SuisseIntlMedium",
    margin: "8px auto 12px auto",
    justifySelf: "center",
    fontSize: "18px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "20px",
      margin: "0 0 10px"
    }
  },
  assignToMeConfirmationHeaderTitle: {
    fontSize: "20px",
    marginBottom: 10
  },
  confirmationText: {
    flex: "auto",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    color: theme.palette.text.secondary
  },
  confirmationTextAmount: {
    display: "contents",
    fontFamily: "SuisseIntlMedium",
    color: theme.palette.text.primary
  },
  confirmationButtons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "12px",
    width: "100%",
    backgroundColor: "#fff",
    boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.2)",
    "& > .MuiButton-root": {
      fontSize: "16px"
    }
  },
  confirmationButtonsConfirm: {
    color: theme.palette.secondary.dark
  },
  cancelButton: {
    color: theme.palette.primary.dark,
    marginRight: 6
  },
  assignToMeConfirmationButtons: {
    height: 36,
    display: "flex",
    alignItems: "center",
    "& > .MuiButton-root": {
      fontSize: "16px",
      height: 32
    }
  },
  confirmAssignmentContainer: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: theme.heightFooter
    }
  },
  confirmAssignment: {
    fontSize: "12px",
    minWidth: "136px",
    margin: "0 34px 0 8px",
    color: theme.palette.text.primary,
    backgroundColor: "rgba(3, 243, 178, 1.0)",
    borderRadius: "2px",
    "&:hover": {
      backgroundColor: "rgba(3, 243, 178, 1.0)"
    },
    "& > .MuiButton-label": {
      display: "flex",
      flexDirection: "column"
    },
    "&.Mui-disabled": {
      backgroundColor: "#d8d8d8",
      color: theme.palette.text.secondary
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px",
      width: "100%",
      height: "100%",
      margin: 0
    }
  },
  confirmAssignmentAmount: {
    fontSize: "14px"
  },
  closeAssignment: {
    color: "rgba(3, 243, 178, 1.0)",
    fontSize: "18px",
    marginBottom: "12px",
    "& > span": {
      textTransform: "none"
    }
  },
  assignLoader: {
    height: "auto"
  }
}));
